import { Pagination } from 'antd';
import React from 'react';
import { Link } from 'react-router-dom';

type WorkshiftTableProps = {
  data: {
    name: string;
    french_name: string;
    hours_per_week: string;
  }[];
  onChangeName: (value: string) => void;
  onChangeDescription: (value: string) => void;
  onChangeHoursPerWeek: (value: string) => void;
  onChange: (value: number) => void;
  itemRender: any;
  currentPage: number;
  count: number;
};

const WorkshiftTable = ({
  data,
  onChangeDescription,
  onChangeHoursPerWeek,
  onChangeName,
  onChange,
  count,
  currentPage,
  itemRender,
}: WorkshiftTableProps) => {
  const formatTotalHour = (totalSeconds: number) => {
    if (totalSeconds) {
      const hours = Math.floor(totalSeconds / 3600);
      const remainingSeconds = totalSeconds % 3600;
      const minutes = Math.floor(remainingSeconds / 60);
      const formattedMinutes = minutes < 10 ? `0${minutes}` : `${minutes}`;
      return `${hours}:${formattedMinutes}`;
    } else return '0:00';
  };

  return (
    <div style={{ marginBottom: 50 }}>
      <div
        style={{
          display: 'flex',
          gap: 20,
          width: '100%',
          borderBottom: '0.5px solid #73A1E7',
          height: 70,
          paddingBottom: 10,
          paddingRight: 16,
        }}
      >
        <div style={{ width: '7%' }}></div>
        <div
          style={{
            width: '31%',
            justifyContent: 'center',
            fontWeight: 600,
            flexDirection: 'column',
            display: 'flex',
            color: '#000000',
          }}
        >
          Name
          <input
            onChange={(e) => onChangeName(e.target.value)}
            style={{ marginTop: '10px' }}
            className="common_custom_input_search"
          />
        </div>
        <div
          style={{
            width: '31%',
            justifyContent: 'center',
            fontWeight: 600,
            flexDirection: 'column',
            display: 'flex',
            color: '#000000',
          }}
        >
          Description
          <input
            onChange={(e) => onChangeDescription(e.target.value)}
            style={{ marginTop: '10px' }}
            className="common_custom_input_search"
          />
        </div>
        <div
          style={{
            width: '31%',
            justifyContent: 'center',
            fontWeight: 600,
            flexDirection: 'column',
            display: 'flex',
            color: '#000000',
          }}
        >
          Total hours
          <input
            onChange={(e: React.ChangeEvent<HTMLInputElement>) =>
              onChangeHoursPerWeek(e.target.value)
            }
            onKeyDown={(e: React.KeyboardEvent<HTMLInputElement>) => {
              const allowedChars = /^[0-9:]$/;
              if (
                !allowedChars.test(e.key) &&
                e.key !== 'Delete' &&
                e.key !== 'Backspace'
              ) {
                e.preventDefault();
              }
            }}
            style={{ marginTop: '10px' }}
            className="common_custom_input_search"
          />
        </div>
      </div>
      {data?.length > 0 ? (
        data?.map((item: any, index: number) => (
          <Link
            to={`/general_settings/workshift_calendar/detail`}
            className="hoverCell"
            key={index}
            style={{
              display: 'flex',
              borderBottom: '0.5px solid #73A1E7',
              width: '100%',
              gap: 20,
              color: '#333',
            }}
            state={{
              id: item?.id,
              name: item.name,
            }}
          >
            <div
              style={{
                width: '7%',
                justifyContent: 'center',
                display: 'flex',
                alignItems: 'center',
              }}
            >
              {/* <img src="/icons/delete_but.svg" alt="delete" /> */}
            </div>
            <div
              style={{
                width: '31%',
                height: 50,
                display: 'flex',
                alignItems: 'center',
                color: '#000000',
                fontSize: '12px',
                fontWeight: '400px',
                fontFamily: 'IBM Plex Serif',
              }}
            >
              {item.name}
            </div>
            <div
              style={{
                width: '31%',
                display: 'flex',
                alignItems: 'center',
                color: '#000000',
                fontSize: '12px',
                fontWeight: '400px',
                fontFamily: 'IBM Plex Serif',
              }}
            >
              {item.description}
            </div>
            <div
              style={{
                width: '31%',
                display: 'flex',
                alignItems: 'center',
                color: '#000000',
                fontSize: '12px',
                fontWeight: '400px',
                fontFamily: 'IBM Plex Serif',
              }}
            >
              {formatTotalHour(item.hours_per_week)}
            </div>
          </Link>
        ))
      ) : (
        <p style={{ textAlign: 'center', color: '#E4E4E4', marginTop: 20 }}>
          No item
        </p>
      )}
      {data?.length > 0 && (
        <div className="is-flex is-justify-content-center is-align-content-center mt-2 staff_leave_footer">
          <Pagination
            showSizeChanger={false}
            itemRender={itemRender}
            current={currentPage}
            onChange={onChange}
            total={count}
            pageSize={10}
          />
        </div>
      )}
    </div>
  );
};

export default WorkshiftTable;
